// extracted by mini-css-extract-plugin
module.exports = {"user":"MenuHeader_user__1c_lX","link":"MenuHeader_link__3N5YT","avatar":"MenuHeader_avatar__KKKCo","username":"MenuHeader_username__2DUxf"};